import { Box, Grid, Typography } from '@mui/material'
import { useContext, useEffect, useState } from 'react'
import styles from './../../../../assets/styles/componentStyles/chatLogsStyles/chatLogsTemplatePreview.module.scss'
import whatsappPreviewStyles from './../../../../assets/styles/componentStyles/templateLibraryStyles/whatsappTemplatePreview.module.scss'
import defaultWATemplateImg from "../../../../assets/images/messageFormats/defaultWATemplateImage.png";
import { Handle, Position } from '@xyflow/react';
import { WorkflowContext, WorkflowContextPayload } from '../../../../context/workflowContext';
import { chatbotIntegratedChannelDeploymentObj, getTemplateDetails, whatsappTemplateButtonData } from '../../../../models/axiosModel';
import { ActionTemplateVariableData, ChatbotStepActionData, SendWADMTemplateActionData } from '../../../../models/flowBuilderTypes';
import globalStyles from '../../../../assets/styles/global.module.scss';
import workflowStyles from '../../../../assets/styles/componentStyles/workflowStyles/workflowStyle.module.scss';
import { isCurrentViewVersionPublished, isSendOrderDetailTemplateActionType } from '../utilityFunctions';
import { replacingTemplateMarkdownText } from '../../../../utils/constants';
import { isMediaHeaderInTemplate, renderTemplateDetailsGridInNode } from '../flowBuilderConstants';
import { subButtonTypeIconMap } from '../../templatelibrary/constant';
import { isTemplateTypeCallPermissionRequest, shouldRenderBtnIcon } from '../../channels/global/whatsapp/templates/utils';
import CallPermissionRequestPreview from '../../templatelibrary/WhatsAppTemplatePreview/CallPermissionRequestPreview';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const TemplateBlock = (
    { id, data }: { id: string, data: ChatbotStepActionData<SendWADMTemplateActionData> }
) => {
    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload
    const [messageTemplateDetail, setMessageTemplateDetail] = useState<getTemplateDetails | null>(null)
    useEffect(() => {
        let messageTemplate = currentActiveStaticWorkflow?.additional_data?.whatsapp_templates?.find((template) => Number(template.whatsapp_template_id) == Number((data.action_data as SendWADMTemplateActionData).whatsapp_template.whatsapp_template_id))
        if (messageTemplate) {
            setMessageTemplateDetail(messageTemplate)
        }
    }, [data.action_data])

    const isCallPermissionRequest = isTemplateTypeCallPermissionRequest(messageTemplateDetail?.whatsapp_template_type?.name);
    const wabaName = (currentActiveStaticWorkflow?.chatbot_integrated_channel_deployment?.integrated_channel_data?.[0] as chatbotIntegratedChannelDeploymentObj | undefined)?.waba_name || "WhatsApp Business";

    function replaceWithSpanTags(bodyText: string) {
        let result = bodyText;
        if ((data.action_data.action_send_dm_wa_template_variable_data as ActionTemplateVariableData[])?.length > 0) {

            // Iterate through each variable mapping from action
            (data.action_data.action_send_dm_wa_template_variable_data as ActionTemplateVariableData[]).forEach((variable) => {
                if (messageTemplateDetail) {

                    let variableKeyToReplace: any = messageTemplateDetail?.whatsapp_template_data?.[0]?.whatsapp_template_body?.whatsapp_template_body_variable_data.find((variable1: any) => variable1.whatsapp_template_dynamic_variable_id == variable.whatsapp_template_dynamic_variable_id)?.whatsapp_template_dynamic_variable_key
                    const variableKey = variableKeyToReplace
                    let variableName = ""
                    if (variableKey) {
                        if (variable?.chatbot_custom_variable_configuration) {
                            variableName = `{{${variable?.chatbot_custom_variable_configuration?.chatbot_custom_variable_name}}}`
                        } else if (variable?.fallback_value) {
                            variableName = variable.fallback_value
                        } else {
                            variableName = messageTemplateDetail?.whatsapp_template_data[0]?.whatsapp_template_body?.whatsapp_template_body_variable_data[0]?.whatsapp_template_dynamic_variable_key
                        }
                        // Create a span tag with a style, you can modify the style as needed
                        const spanTag = `<span style="color: blue; font-weight: bold;">${variableName}</span>`;
                        // Replace the placeholder with the span tag
                        result = result.replace(variableKey, spanTag);
                    }
                }
            });
        }

        result = result.replace(/\*(.*?)\*/g, '<b>$1</b>');  // Bold
        result = result.replace(/\\n/g, '<br>');

        return result;
    }

    function replaceWithSpanTagsHeader(bodyText: string) {
        let result = bodyText;
        if ((data.action_data.action_send_dm_wa_template_variable_data as ActionTemplateVariableData[])?.length > 0) {

            // Iterate through each variable mapping from action
            (data.action_data.action_send_dm_wa_template_variable_data as ActionTemplateVariableData[]).forEach((variable: any) => {
                // @ts-ignore
                let variableKeyToReplace: any = messageTemplateDetail?.whatsapp_template_data?.[0]?.whatsapp_template_header?.whatsapp_template_header_data[0]?.whatsapp_template_header_variable_data.find((variable1: any) => Number(variable1.whatsapp_template_dynamic_variable_id) == Number(variable.whatsapp_template_dynamic_variable_id))?.whatsapp_template_dynamic_variable_key
                const variableKey = variableKeyToReplace
                let variableName = "";
                if (variableKey) {
                    if (variable?.chatbot_custom_variable_configuration) {
                        variableName = `{{${variable?.chatbot_custom_variable_configuration?.chatbot_custom_variable_name}}}`
                    } else if (variable?.fallback_value) {
                        variableName = variable.fallback_value
                    } else {
                        // @ts-ignore
                        variableName = variableKeyToReplace
                    }
                    // Create a span tag with a style, you can modify the style as needed
                    const spanTag = `<span style="color: blue; font-weight: bold;">${variableName}</span>`;
                    // Replace the placeholder with the span tag
                    result = result.replace(variableKey, spanTag);
                }
            });
        }

        result = result.replace(/\*(.*?)\*/g, '<b>$1</b>');  // Bold
        result = result.replace(/\\n/g, '<br>');

        return result;
    }

    const messageText = (type: string) => {
        let template: string = "";

        if (type?.toLowerCase() === "body") {
            return replaceWithSpanTags(messageTemplateDetail?.whatsapp_template_data?.[0]?.whatsapp_template_body?.whatsapp_template_body_value || "-")
        }

        else if (type?.toLowerCase() === "header") {
            // if (((data.action_data as SendWADMTemplateActionData).action_send_dm_wa_template_variable_data as ActionTemplateVariableData)?.chatbot_custom_variable_configuration) {
            //     return ((data.action_data as SendWADMTemplateActionData).action_send_dm_wa_template_variable_data as ActionTemplateVariableData)?.chatbot_custom_variable_configuration?.chatbot_custom_variable_fallback_value || "-"
            // }
            // template = messageTemplateDetail?.whatsapp_template_data?.[0]?.whatsapp_template_header?.whatsapp_template_header_data?.[0]?.whatsapp_template_header_data_value || "-"
            return replaceWithSpanTagsHeader(messageTemplateDetail?.whatsapp_template_data?.[0]?.whatsapp_template_header?.whatsapp_template_header_data?.[0]?.whatsapp_template_header_data_value || "-")
        }

        else {
            template = messageTemplateDetail?.whatsapp_template_data?.[0]?.whatsapp_template_footer?.whatsapp_template_footer_value || "-"
        }
        return replacingTemplateMarkdownText(template);
    }

    const getSubButtonText = (subBtnData: whatsappTemplateButtonData) => {
        const fieldVal = subBtnData?.whatsapp_template_button_sub_type_field_data
            ?.find((field: any) => field.field_name === "Button Text");

        return typeof fieldVal?.whatsapp_template_button_sub_type_field_value === "string"
            ? fieldVal.whatsapp_template_button_sub_type_field_value // returned if it's a string
            : "-"; // returned otherwise, this case is for payload which we dont need to worry
    };
    function getHeaderMedia() {
        let actionVarConfig = (data.action_data.action_send_dm_wa_template_variable_data as ActionTemplateVariableData[]).find((variable: any) => variable.whatsapp_template_dynamic_variable_id == messageTemplateDetail?.whatsapp_template_data?.[0]?.whatsapp_template_header?.whatsapp_template_header_data[0]?.whatsapp_template_header_variable_data[0]?.whatsapp_template_dynamic_variable_id)
        if (actionVarConfig?.chatbot_custom_variable_configuration) {
            return actionVarConfig.chatbot_custom_variable_configuration.chatbot_custom_variable_fallback_value
        } else if (actionVarConfig?.fallback_value) {
            return actionVarConfig.fallback_value
        } else {
            return messageTemplateDetail?.whatsapp_template_data?.[0]?.whatsapp_template_header.whatsapp_template_header_data[0]?.whatsapp_template_header_variable_data[0]?.whatsapp_template_dynamic_variable_sample_value || defaultWATemplateImg
        }
    }

    const getLocationHeaderField = (variableKey: string) => {
        const fieldId = messageTemplateDetail?.whatsapp_template_data?.[0]?.whatsapp_template_header?.whatsapp_template_header_data[0]?.whatsapp_template_header_variable_data?.find((variable: any) => variable?.whatsapp_template_dynamic_variable_key?.toLowerCase() === variableKey?.toLowerCase())?.whatsapp_template_dynamic_variable_id;
        if(fieldId){
            const headerField = (data?.action_data?.action_send_dm_wa_template_variable_data as ActionTemplateVariableData[])?.find((variable: any) => String(variable?.whatsapp_template_dynamic_variable_id) === String(fieldId));
    
            if(headerField) {
                let fieldVariableKey = variableKey;
    
                if(headerField?.chatbot_custom_variable_configuration) {
                    fieldVariableKey = `{{${headerField?.chatbot_custom_variable_configuration?.chatbot_custom_variable_name}}}`;
                } else if(headerField?.fallback_value) {
                    fieldVariableKey = headerField?.fallback_value;
                }
    
                return <span 
                        style={{ color: "blue", fontWeight: "bold" }}
                    >
                        {fieldVariableKey}
                    </span>;
            }
        }
        return <></>;
    }

    const renderHeader = () => {
        const headerType = messageTemplateDetail?.whatsapp_template_data?.[0]?.whatsapp_template_header?.whatsapp_template_header_type_name?.toLowerCase() ?? "";

        switch (headerType) {
            case 'image':
                return (
                    <Grid item className={globalStyles.overflowHidden}>
                        <img alt=";php" src={getHeaderMedia() || ""}
                            className={styles.templatePreviewHeaderImage} />
                    </Grid>
                );
            case 'video':
                return (
                    <Grid item>
                        <video key={getHeaderMedia()} style={{ width: "100%", maxHeight: "200px" }} controls className='video-tag'>
                            {/* <source src={messageTemplateDetail?.whatsapp_template_data?.[0]?.whatsapp_template_header?.whatsapp_template_header_data?.[0]?.whatsapp_template_header_data_value || ""} type="video/mp4" /> */}
                            <source src={getHeaderMedia() ?? ''} type="video/mp4" />
                        </video>
                    </Grid>
                );
            case 'text':
                return (
                    <Grid item className={styles.templatePrviewHeaderItem}>
                        <pre
                            className={styles.preTextStyle}
                            dangerouslySetInnerHTML={{ __html: messageText("header") }}
                        />
                    </Grid>
                );
            case 'location':
                return (
                    <Box className={whatsappPreviewStyles.whatsappPreview__locationHeader}>
                        <Box className={whatsappPreviewStyles.whatsappPreview__locationHeaderMap}>
                            <LocationOnIcon className={whatsappPreviewStyles.whatsappPreview__locationHeaderMapIcon} />
                        </Box>
                        <Box className={whatsappPreviewStyles.whatsappPreview__locationHeaderFields}>
                            <Box className={`${whatsappPreviewStyles.whatsappPreview__locationHeaderField} ${whatsappPreviewStyles["whatsappPreview__locationHeaderField--name"]}`}>
                                <Typography className={whatsappPreviewStyles.whatsappPreview__locationHeaderNameText}>
                                    {getLocationHeaderField("{{name}}")}
                                </Typography>
                            </Box>

                            <Box className={whatsappPreviewStyles.whatsappPreview__locationHeaderField}>
                                <Typography className={whatsappPreviewStyles.whatsappPreview__locationHeaderAddressText}>
                                    {getLocationHeaderField("{{address}}")}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                );

            default: 
            return null;
        }
    }

    return (
        <>
            {messageTemplateDetail &&
                <>
                    <Grid item padding={"0px"} className={`${styles.previewSectionCardBlock} ${!id ? styles.templatePreviewBorderRadius : ""}`}>
                        <>
                            {renderTemplateDetailsGridInNode(messageTemplateDetail, currentActiveStaticWorkflow)}
                        </>
                        <Grid container direction={"column"} gap={"4px"}>
                            {renderHeader()}
                            <Grid item className={`${(isMediaHeaderInTemplate(messageTemplateDetail?.whatsapp_template_data?.[0]?.whatsapp_template_header?.whatsapp_template_header_type_name)) ? styles.templatePrviewBodyItem : styles.templatePrviewBodyItemWithMediaHeader}`} mb={"4px"}>
                                <pre
                                    className={styles.preTextStyle}
                                    dangerouslySetInnerHTML={{ __html: messageText("body") }}
                                />
                            </Grid>

                            {messageTemplateDetail?.whatsapp_template_data?.[0]?.whatsapp_template_footer?.whatsapp_template_footer_value && messageTemplateDetail?.whatsapp_template_data?.[0]?.whatsapp_template_footer?.whatsapp_template_footer_value?.length > 0 &&
                                <Grid item className={styles.templatePrviewFooterItem}>
                                    <pre
                                        className={styles.preTextStyle}
                                        dangerouslySetInnerHTML={{ __html: messageText("footer") }}
                                    />
                                </Grid>
                            } 

                            {isSendOrderDetailTemplateActionType(data?.action_type?.action_type_name) && // Only for Send Order Detail Template
                                <Grid item paddingBlock={"10px"} className={`${styles.templatePreviewButtonItem} ${styles.templatePreviewButtonItemBorder} ${workflowStyles.templateButton}`}>
                                    <Grid container justifyContent={"center"} gap={1} alignItems={"center"} className={globalStyles.relativePosition}>
                                        <Grid item>
                                            {"Review and Pay"}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            }

                            {messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_button?.length > 0 && messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_button.flatMap((btn: any) => btn.whatsapp_template_button_data).map((subBtnData: any, ind: number) =>
                                <Grid item padding={"0px"} className={styles.templatePreviewBorderRadius}>
                                    <Grid item paddingBlock={"10px"} className={`${styles.templatePreviewButtonItem} ${styles.templatePreviewButtonItemBorder} ${workflowStyles.templateButton}`}>
                                        <Grid container justifyContent={"center"} gap={1} alignItems={"center"} className={globalStyles.relativePosition}>
                                            {shouldRenderBtnIcon(messageTemplateDetail, subBtnData?.whatsapp_template_button_sub_type_name) &&
                                                <Grid item>
                                                    {subButtonTypeIconMap[subBtnData?.whatsapp_template_button_sub_type_name?.toLowerCase() as keyof typeof subButtonTypeIconMap]}
                                                </Grid>
                                            }
                                            <Grid item>
                                                {getSubButtonText(subBtnData)}
                                            </Grid>
                                            {subBtnData.whatsapp_template_button_type_name == "Quick reply" &&
                                                <Handle type="source" position={Position.Right}
                                                    isConnectable={!isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                                    id={subBtnData?.whatsapp_template_button_id ? subBtnData?.whatsapp_template_button_id : ""}
                                                />}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            )}

                        </Grid>
                        
                        {isCallPermissionRequest && (
                            <Grid item className={styles.nodeCallPermissionPreview}>
                                <CallPermissionRequestPreview wabaName={wabaName} fullWidth variant="primary" />
                            </Grid>
                        )}
                    </Grid>
                </>
            }
        </>
    )
}

export default TemplateBlock